import Vue from 'vue'
Vue.component('footer-cont', {
  props: ['buylink'],
  data(){
	  return {
		  langlist: [],
		  colunmlist:[]
	  }
  },



  created:function(){


		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:10},
			  'Content-Type':"application/json",
			  success:function(res){

				  $.each(res.bizData.list,function(i,v){
					  var linkurl;
					  if(v.code=='en'){
						  linkurl = '../index.html';
					  }
					  if(v.code=='jp'){
						  linkurl = '../jp/index.html';
					  }
					  if(v.code=='es'){
						  linkurl = '../es/index.html';
					  }
					  if(v.code=='kr'){
						  linkurl = '../kr/index.html';
					  }
					  res.bizData.list[i].linkurl = linkurl;


				  })
				  self.langlist = res.bizData.list;
			  }
		  })

		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchContent ',
			  data: {productId:ProductId,channelCode:'case',lang:'en',pageNo:0,pageSize:3},
			  'Content-Type':"application/json",
			  success:function(res){
				  self.colunmlist = res.bizData.list;
			  }
		   })
  },
  methods:{
	  Getdownlink1:function(){

			gtag_report_conversion();
	  },

	  Getdownlink2:function(){

			gtag_report_conversion();
    },

  },
  template: '<div class="footer">\
  <div class="top or mainbox">\
   <h2 class="wow bounceInDown" data-wow-delay="0s">DWG FastView Plus</h2>\
   <h3 class="wow fadeInUpSmall" data-wow-delay="0.2s">Fast view  & Flexible measure & Easy share</h3>\
   <div class="btn wow fadeInUpSmall" data-wow-delay="0.3s"><a href="javascript:;" v-on:click="Getdownlink1" class="n1 btnicon downlinkMar"><i></i><em>Try It Free</em></a><a v-on:click="Getdownlink2" v-bind:href="buylink" class="n2 btnicon"><i></i><em>Buy Now</em></a></div>\
  </div>\
  <!--top-->\
  <div class="cl"></div>\
  <div class="bottom mainbox wow fadeIn">\
   <div class="left_cor">\
    <div class="foot_logo"><em></em>DWG FastView <i>+</i></div>\
    <div class="language">\
     <h3>Language</h3>\
     <ul>\
      <li><a href="javascript:;">English<i></i></a>\
       <dl>\
        <dt v-for="item in langlist"><a :href="item.linkurl">{{item.name}}</a></dt>\
       </dl>\
      </li>\
     </ul>\
    </div>\
    <!--language-->\
   </div>\
   <!--left_cor-->\
   <div class="right_cor">\
    <ul>\
     <li><h3>Products</h3></li>\
     <li><a href="../index/">DWG FastView Plus</a></li>\
     <li><a href="http://3dview.cadwonder.net" target="_blank">3D FastView</a></li>\
    </ul>\
    <ul>\
     <li><h3>Support</h3></li>\
     <li><a href="../userguide/">Documentation</a></li>\
     <li><a href="../videotutorials/">Video Resources</a></li>\
     <li><a href="../emailus/">Contact Us</a></li>\
    </ul>\
    <ul>\
     <li><h3>Case Studies</h3></li>\
     <li v-for="item in colunmlist"><a :href="\'../content/index.html?id=\'+item.id">{{item.shortTitle}}</a></li>\
    </ul>\
   </div>\
   <!--right_cor-->\
  </div>\
  <!--bottom-->\
  <div class="dollow_us cl mainbox  wow fadeIn">\
   <h3>Follow Us</h3>\
   <span><a href="https://www.linkedin.com/company/2444016" target="_blank" class="icon1"><i></i></a><a href="https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w" target="_blank" class="icon2"><i></i></a><a href="https://www.facebook.com/DWG-FastView-Plus-968128393349711/" target="_blank" class="icon3"><i></i></a><a href="https://twitter.com/Gstarsoft_CAD" target="_blank" class="icon4"><i></i></a></span>\
  </div>\
  <p class="rightcopy  wow fadeIn">©Copyright 2019 Gstarsoft Co.,Ltd. All rights reserved.</p>\
  <div class="oem_mask"></div><div class="oem_mask_model">\
  <div class="oem_mask_header">\
            Gstarsoft\
            <span class="oem_mask_close" onclick="closeOemMask(this)"></span>\
        </div>\
        <div class="oem_mask_txt">Please input your Email, we will send you the installation package via Email in 24 hours. Please download it on PC</div>\
        <input class="oem_mask_input" type="text" value=""/>\
        <span class="oem_mask_error"></span>\
        <a class="oem_mask_btn" onclick="purchaseSubmit(this,\'en\',\'Confirm\')">Confirm</a>\
  </div>\
  </div>',

});

Vue.component('header-cont', {
  props: ['onpages','buylink','othercss'],
  data(){
	  return {
		  langlist: [],
		  isopen:false,
		  checkedlang:'English',
		  bit:32,
      lang:'en'
	  }
  },
  created:function(){
		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:10},
			  'Content-Type':"application/json",
			  success:function(res){
				  self.langlist = res.bizData.list;
			  }
      });



  },
  methods:{

    openselect:function(){

		var self = this;
		self.isopen = true;

	},

	checkedlag:function(code,name){

		var self = this;
		self.checkedlang = name;
		self.lang = code;
		self.isopen = false;

	},



	Getdownlink:function(){
		gtag_report_conversion();
		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/downInstallPackage ',
			  data: {productId:ProductId,versionId:1,lang:self.lang,bit:self.bit},
			  'Content-Type':"application/json",
			  success:function(res){

				  window.location.href=res.bizData.downloadLink
			  }
		  })

	}

  },
  template: '<div>\
	<div class="header down" v-bind:class="{bgf:othercss==1}"><a href="javascript:;" class="menu_bt"><span>Menu</span></a>\
  <div class="con">\
   <div class="logo"><a href="https://www.gstarcad.net/Eshop" target="_blank"></a></div>\
    <div class="page-overlay">\
      <div class="nav">\
        <ul>\
          <li v-bind:class="{on:onpages==99}"><a href="http://www.cadwonder.net" target="_blank">Home</a></li>\
          <li v-bind:class="{on:onpages==1}"><a href="../index/">DWG FastView<i>+</i></a></li>\
          <li v-bind:class="{on:onpages==2}"><a href="../Learnmore/">Features</a></li>\
          <li v-bind:class="{on:onpages==3}"><a href="../support/">Support</a></li>\
          <li v-bind:class="{on:onpages==4}"><a href="../review/">Reviews</a></li>\
          <li v-bind:class="{on:onpages==5}"><a href="../case/">Case Studies</a></li>\
        </ul>\
      </div>\
      <div class="header_btn"><a href="javascript:;" class="bt1 downbtn">Download</a><em></em><a href="../buy/" class="bt2"><span data-hover="Buy">Buy</span></a></div>\
    </div>\
    <!--page-overlay--> \
  </div>\
  <!--con-->\
</div>\
<div class="mask"></div>\
<a href="javascript:;" class="popover_close"></a>\
<div class="popover" id="dowmnmart">\
 <div class="top"><i></i>Download Software</div>\
 <div class="con">\
  <div class="bit">\
   <h3>Version</h3>\
   <div class="bit_con">\
       <label><input type="radio" checked name="bit" v-model="bit" value="32"><i></i>32 bit</label>\
       <label><input type="radio" name="bit" v-model="bit" value="64"><i></i>64 bit</label>\
   </div>\
  </div>\
  <!--bit-->\
  <div class="language">\
    <h3>Language</h3>\
    <div class="select">\
      <div class="select_text" v-on:click="openselect">{{checkedlang}}</div>\
      <ul class="select_ul" v-if="isopen==true" style="display:block;">\
        <li v-for="item in langlist" v-on:click="checkedlag(item.code,item.name)">{{item.name}}</li>\
      </ul>\
    </div>\
    </div>\
    <!--language-->\
    <div class="btn"><a href="javascript:;" class="close">Cancel</a><a v-on:click="Getdownlink" class="submit" href="javascript:;">Confirm</a></div>\
 </div>\
 <!--con-->\
</div>\
<!--下载弹出-->\
</div>\
',

});

Vue.component('slider-cont', {
  props: ['onnav'],
  template: '<div class="left_side wow fadeInLeftSmall">\
  <ul>\
   <li><h2>Documentation</h2></li>\
   <li v-bind:class="{on:onnav==1}"><a href="../userguide/">User Guide</a></li>\
   <li v-bind:class="{on:onnav==2}"><a href="../howto/">How to</a></li>\
  </ul>\
  <ul>\
   <li><h2>Resourse</h2></li>\
   <li v-bind:class="{on:onnav==3}"><a href="../productoverview/">Product Overview</a></li>\
   <li v-bind:class="{on:onnav==4}"><a href="../videotutorials/">Video Tutorials</a></li>\
  </ul>\
  <ul>\
   <li><h2>Technical Support</h2></li>\
   <li v-bind:class="{on:onnav==5}"><a href="../emailus/">Email Us</a></li>\
   <li><a href="https://www.facebook.com/DWG-FastView-Plus-968128393349711/" target="_blank">Online Help</a></li>\
  </ul>\
  </div>',
});

Vue.component('down-cont', {
  template: '<div class="downcomone">\
	 <!--侧边栏-->\
	 <ul class="side-bar slideInRight">\
	  <li class="s1"><a href="#"><i></i></a></li>\
	  <li class="s2"><a href="#"><i></i></a></li>\
	  <li class="s3"><a href="#"><i></i></a></li>\
	 </ul>\
	<div class="mask"></div>\
	<a href="#" class="popover_close"></a>\
	<div class="popover">\
	 <div class="top"><i></i>Download Software</div>\
	 <div class="con">\
	 <form>\
	  <div class="bit">\
	   <h3>Version</h3>\
	   <div class="bit_con">\
		   <label><input type="radio" checked name="hot"><i></i>32 bit</label>\
		   <label><input type="radio" name="hot"><i></i>64 bit</label>\
	   </div>\
	  </div>\
	  <!--bit-->\
	  <div class="language">\
		<h3>Language</h3>\
		<select class="select">\
		  <option value ="0">English</option>\
		  <option value ="1" >한국어</option>\
		  <option value ="2" >日本语</option>\
		</select>\
		</div>\
		<!--language-->\
		<div class="btn"><a href="javscript:;" class="close">Cancel</a><input type="submit" value="Confirm"></div>\
	  </form>\
	 </div>\
	 <!--con-->\
	</div>\
	<!--下载弹出-->\
	</div>',
});

Vue.component('search-cont', {
  data(){
	  return {
		  key: '',
	  }
  },
  methods:{

	  search:function(){
		  var self= this;
		  window.location.href="../result/index.html?key="+self.key;

	  }

  },
  template: '<div class="cases_banner">\
 <div class="mainbox">\
  <input type="text" v-model="key" placeholder="Hi, how can we help you?" class="text" @keyup.enter="search">\
  <button v-on:click="search"><i></i>Search Now</button>\
 </div>\
</div>',
});





// WEBPACK FOOTER //
// ./static/en/vue-components.js